import gql from 'graphql-tag';

export const updateRole = gql`
  mutation updateRole($id: ID!, $input: UpdateRoleInput) {
    updateRole(id: $id, input: $input) {
      id
      name
      claims {
        id
        name
      }
      businessUnits {
        id
        name
      }
    }
  }
`;
